import { render, staticRenderFns } from "./my_goods.vue?vue&type=template&id=a1473fe4&scoped=true"
import script from "./my_goods.vue?vue&type=script&lang=js"
export * from "./my_goods.vue?vue&type=script&lang=js"
import style0 from "./my_goods.vue?vue&type=style&index=0&id=a1473fe4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1473fe4",
  null
  
)

export default component.exports